angular.module('manufacturing')
    .component('manufacturingOrderTechnologyOptions', {
        bindings: {
            requirements: '=',
            editable: '<?',
            compact: '<?',
            preview: '<?',
            inlineFiberSettings: '<?'
        },
        templateUrl: 'app/manufacturing/technology-options.html',
        controller: function (Principal) {
            this.$onInit = () => {
                this.editable = this.editable === true
                this.compact = this.compact === true
                this.preview = this.preview === true
                this.inlineFiberSettings = this.inlineFiberSettings === true
                this.canManageFiberTypes = Principal.hasAnyAuthority(['ROLE_MANUFACTURING_ORDER_MANAGEMENT'])
                this.initializeRequirements()
            }

            this.$onChanges = changes => {
                if (changes.requirements) {
                    this.initializeRequirements()
                }
            }

            this.initializeRequirements = () => {
                if (this.requirements == null) {
                    this.requirements = {}
                }
                this.requirements.heated = this.requirements.heated === true
                this.requirements.frostResistant = this.requirements.frostResistant === true
                this.fiberEnabled = this.requirements.fiberType != null || this.requirements.fiberDosage != null
            }

            this.toggle = property => {
                if (this.editable) {
                    this.requirements[property] = !this.requirements[property]
                }
            }

            this.toggleFiber = () => {
                if (!this.editable) {
                    return
                }
                this.fiberEnabled = !this.fiberEnabled
                if (!this.fiberEnabled) {
                    delete this.requirements.fiberType
                    delete this.requirements.fiberDosage
                }
            }

            this.hasAnyOption = () => this.requirements != null && (this.requirements.heated || this.requirements.frostResistant || this.requirements.fiberType != null)

            this.fiberDescription = () => {
                if (this.requirements == null || this.requirements.fiberType == null) {
                    return ''
                }
                let description = this.requirements.fiberType.name
                if (this.requirements.fiberDosage != null) {
                    description += `, ${this.requirements.fiberDosage} kg/m³`
                }
                return description
            }
        }
    })
